import { defineAsyncComponent } from 'vue';
import type { App, Component } from 'vue';
import consola from 'consola';
import type { Plugin } from 'vue';
import AxModalLoading from './AxModalLoading.vue';

export const uiBlocksPlugin: Plugin = {
    install: async (app: App) => {
        try {
            Object.entries(uiBlocks).forEach(([name, component]) => {
                app.component(name, component);
            });

            if (import.meta.env.MODE === 'development') {
                consola.success('Blocks UI registered');
            }
        } catch (error) {
            consola.error('Error registering blocks UI:', error);
        }
    },
};

const uiBlocks: Record<string, Component> = {
    AxCard: defineAsyncComponent(() => import('./AxCard.vue')),
    AxFileIcon: defineAsyncComponent(() => import('./AxFileIcon.vue')),
    AxFolderButton: defineAsyncComponent(() => import('./AxFolderButton.vue')),
    AxFormCnCompletion: defineAsyncComponent(() => import('./AxFormCnCompletion.vue')),
    AxLcaChip: defineAsyncComponent(() => import('./AxLcaChip.vue')),
    AxMenuButton: defineAsyncComponent(() => import('./AxMenuButton.vue')),
    AxModalLoading,
    AxMultiSelectUsers: defineAsyncComponent(() => import('./AxMultiSelectUsers.vue')),
    AxSelectUsers: defineAsyncComponent(() => import('./AxSelectUsers.vue')),
    AxWorkflowDot: defineAsyncComponent(() => import('./AxWorkflowDot.vue')),
};

export { uiBlocks };
